// Configuración de imágenes por defecto para el sistema
import team3 from '../assets/img/team/3.jpg';

export const DEFAULT_PROFILE_IMAGE = team3;

// Variable para forzar actualización global de imágenes
let globalImageTimestamp = Date.now();

// Sistema de callbacks para notificar cambios de imagen
let imageUpdateCallbacks = [];

export const forceImageRefresh = () => {
  globalImageTimestamp = Date.now();

  // Notificar a todos los componentes registrados
  imageUpdateCallbacks.forEach(callback => {
    try {
      callback();
    } catch (error) {
      console.error('Error en callback de actualización de imagen:', error);
    }
  });
};

export const registerImageUpdateCallback = (callback) => {
  imageUpdateCallbacks.push(callback);
  return () => {
    imageUpdateCallbacks = imageUpdateCallbacks.filter(cb => cb !== callback);
  };
};

export const getDefaultProfileImage = () => {
  return DEFAULT_PROFILE_IMAGE;
};

export const getProfileImageSrc = (user, forceRefresh = false) => {
  // Si el usuario tiene una imagen personalizada, usarla
  if (user?.profileImageUrl) {
    // Extraer timestamp de la URL de Azure Blob Storage o usar updatedAt
    let timestamp;
    
    // Si la URL contiene un timestamp (como avatar-1750969528247.png), usarlo
    const timestampMatch = user.profileImageUrl.match(/avatar-(\d+)\./);
    if (timestampMatch) {
      timestamp = timestampMatch[1];
    } else {
      // Si no, usar updatedAt o timestamp actual
      timestamp = user.updatedAt ? new Date(user.updatedAt).getTime() : Date.now();
    }
    
    // Cache-busting más agresivo cuando se fuerza actualización
    const separator = user.profileImageUrl.includes('?') ? '&' : '?';
    let cacheBuster;
    
    if (forceRefresh) {
      cacheBuster = `v=${timestamp}&_t=${globalImageTimestamp}&r=${Math.random()}&force=${Date.now()}`;
    } else {
      cacheBuster = `v=${timestamp}&_t=${globalImageTimestamp}&u=${user.id}`;
    }
    
    return `${user.profileImageUrl}${separator}${cacheBuster}`;
  }
  
  // Si no, usar la imagen por defecto
  return DEFAULT_PROFILE_IMAGE;
}; 